// Itens do menu lateral da empresa. Cada fatia pode ajustar o rótulo/ícone, mas mantenha as rotas.
import { BarChart3, Bot, Globe, History, Home, LayoutDashboard, LayoutTemplate, Lightbulb, Megaphone, MessageCircle, MousePointerClick, Plug, Radar, Settings, Sparkles, type LucideIcon } from 'lucide-react'
import type { Permission } from '@impulso/shared'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  perm?: Permission
  badge?: 'suggestions'
  /** Submenu: aparece aberto quando a rota atual está dentro de `to` */
  children?: NavItem[]
  /** Só marca como ativo na rota exata (usado no item "Visão geral" de um submenu) */
  end?: boolean
}

export const companyNav: NavItem[] = [
  { to: 'inicio', label: 'Início', icon: Home },
  { to: 'sugestoes', label: 'Sugestões', icon: Lightbulb, badge: 'suggestions' },
  { to: 'ideias', label: 'Ideias da semana', icon: Sparkles, perm: 'company.edit_drafts' },
  { to: 'campanhas', label: 'Campanhas', icon: Megaphone },
  { to: 'resultados', label: 'Resultados', icon: BarChart3 },
  { to: 'vendas', label: 'Clientes e vendas', icon: MessageCircle, perm: 'company.edit_drafts' },
  {
    to: 'trackeamento', label: 'Medição', icon: Radar, perm: 'company.edit_drafts',
    children: [
      { to: 'trackeamento', label: 'Visão geral', icon: LayoutDashboard, end: true },
      { to: 'trackeamento/meu-site', label: 'Meu site', icon: Globe },
      { to: 'trackeamento/landing-pages', label: 'Páginas', icon: LayoutTemplate },
      { to: 'trackeamento/eventos', label: 'Eventos e conversões', icon: MousePointerClick },
      { to: 'trackeamento/analytics', label: 'Visitas do site', icon: BarChart3 },
    ],
  },
  { to: 'piloto', label: 'Piloto automático', icon: Bot, perm: 'company.configure_autopilot' },
  { to: 'historico', label: 'Histórico', icon: History, perm: 'company.edit_drafts' },
]

export const companySettingsNav: NavItem[] = [
  { to: 'contas', label: 'Contas conectadas', icon: Plug, perm: 'company.manage_connections' },
  { to: 'config/negocio', label: 'Configurações', icon: Settings, perm: 'company.edit_settings' },
]
